// extracted by mini-css-extract-plugin
export var compactFilters = "_ga-4";
export var detailImage = "_ga-1";
export var dropdownContainer = "_ga-2";
export var imageContainer = "_ga-0";
export var selectedCard = "_ga-3";